module.exports = __SPARKY_LIBS__["lodash"]["some"];